/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { CollegamentoEsitoDTO } from '../model/collegamento-esito-dto';
// @ts-ignore
import { CollegamentoStatoDTO } from '../model/collegamento-stato-dto';
// @ts-ignore
import { CollegamentoTokenForm } from '../model/collegamento-token-form';
// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { SegnalazioneAccountForm } from '../model/segnalazione-account-form';
// @ts-ignore
import { SegnalazioneAccountInviataDTO } from '../model/segnalazione-account-inviata-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    CollegamentoAccountServiceInterface,
    CollegaAccountIdentitaDigitaleRequestParams,
    SegnalaAccountNonMioRequestParams,
    StatoCollegamentoAccountRequestParams
} from './collegamento-account.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class CollegamentoAccountService extends BaseService implements CollegamentoAccountServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Collega l\&#39;accesso SPID/CIE all\&#39;account registrato con lo stesso codice fiscale.
     * Dopo il collegamento il cittadino accede di nuovo con SPID/CIE ed entra nell\&#39;account esistente; email e password continuano a funzionare. Se l\&#39;account non era mai stato attivato viene attivato e l\&#39;email non verificata viene tolta.
     * @endpoint post /api/v1/account/collegamento-identita/collega
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public collegaAccountIdentitaDigitale(requestParameters: CollegaAccountIdentitaDigitaleRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CollegamentoEsitoDTO>;
    public collegaAccountIdentitaDigitale(requestParameters: CollegaAccountIdentitaDigitaleRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CollegamentoEsitoDTO>>;
    public collegaAccountIdentitaDigitale(requestParameters: CollegaAccountIdentitaDigitaleRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CollegamentoEsitoDTO>>;
    public collegaAccountIdentitaDigitale(requestParameters: CollegaAccountIdentitaDigitaleRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const collegamentoTokenForm = requestParameters?.collegamentoTokenForm;
        if (collegamentoTokenForm === null || collegamentoTokenForm === undefined) {
            throw new Error('Required parameter collegamentoTokenForm was null or undefined when calling collegaAccountIdentitaDigitale.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/account/collegamento-identita/collega`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CollegamentoEsitoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: collegamentoTokenForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Segnala che l\&#39;account registrato con il proprio codice fiscale non è stato creato da sé.
     * Salva la segnalazione con i recapiti per essere ricontattati e avvisa l\&#39;assistenza. Con una segnalazione già aperta per lo stesso codice fiscale risponde con quella.
     * @endpoint post /api/v1/account/collegamento-identita/segnalazione
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public segnalaAccountNonMio(requestParameters: SegnalaAccountNonMioRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<SegnalazioneAccountInviataDTO>;
    public segnalaAccountNonMio(requestParameters: SegnalaAccountNonMioRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<SegnalazioneAccountInviataDTO>>;
    public segnalaAccountNonMio(requestParameters: SegnalaAccountNonMioRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<SegnalazioneAccountInviataDTO>>;
    public segnalaAccountNonMio(requestParameters: SegnalaAccountNonMioRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const segnalazioneAccountForm = requestParameters?.segnalazioneAccountForm;
        if (segnalazioneAccountForm === null || segnalazioneAccountForm === undefined) {
            throw new Error('Required parameter segnalazioneAccountForm was null or undefined when calling segnalaAccountNonMio.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/account/collegamento-identita/segnalazione`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<SegnalazioneAccountInviataDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: segnalazioneAccountForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Situazione dell\&#39;accesso SPID/CIE rispetto a un account esistente.
     * Dice se l\&#39;accesso è già collegato, se esiste un account registrato con lo stesso codice fiscale (con nome, cognome ed email mascherata) o se c\&#39;è una segnalazione in corso. Nessuna scrittura.
     * @endpoint post /api/v1/account/collegamento-identita/stato
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public statoCollegamentoAccount(requestParameters: StatoCollegamentoAccountRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CollegamentoStatoDTO>;
    public statoCollegamentoAccount(requestParameters: StatoCollegamentoAccountRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CollegamentoStatoDTO>>;
    public statoCollegamentoAccount(requestParameters: StatoCollegamentoAccountRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CollegamentoStatoDTO>>;
    public statoCollegamentoAccount(requestParameters: StatoCollegamentoAccountRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const collegamentoTokenForm = requestParameters?.collegamentoTokenForm;
        if (collegamentoTokenForm === null || collegamentoTokenForm === undefined) {
            throw new Error('Required parameter collegamentoTokenForm was null or undefined when calling statoCollegamentoAccount.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/account/collegamento-identita/stato`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CollegamentoStatoDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: collegamentoTokenForm,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
